import Model, { attr } from '@ember-data/model';

import type { DateRangeInterface, DSSetup, RecordData } from 'webapp-types';
import type { Aggregation, SeriesVisualization, ShownLabels } from 'webapp/enums/enums';
import { DataSelectType } from 'webapp/enums/enums';

export default class DataSelectRecord extends Model {
	@attr('number') blockId!: number | null; // null for scorecards not saved to BE yet
	@attr('number', { defaultValue: DataSelectType.MAIN }) declare type: DataSelectType;

	@attr('object') dateRange!: DateRangeInterface.FormulaInterface;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	compares!: DSSetup.Compare[];
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	overrides!: RecordData.DataSelect.Overrides;
	@attr('number') updateFrom!: number | null;

	@attr('string') metricSetupKey!: string | null;
	@attr('number') metricSetupSpaceAccessId!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	metricSetupDimensions!: string[];
	@attr('object') metricSetupFilters!: DSSetup.MetricSetupFiltersData | null;

	// serialized to 'filters' field
	@attr('number') recordLimit!: number | null;
	@attr('number') sortDataSelect!: number | null;

	// serialized to 'config' field
	@attr('boolean') skipAutoUpdate!: boolean;
	@attr('number') constValue!: number | null;
	@attr('string') visualization!: SeriesVisualization | null;
	@attr('boolean') isStacked!: boolean;
	@attr('string') aggregation!: Aggregation | null;
	@attr('string') shownLabels!: ShownLabels;
	@attr('number') startValue!: number | null;
	@attr('number') yAxisIndex!: number | null;
	@attr('number') order!: number | null;
	@attr('number') anomalySensitivity!: number | null;
	@attr('number') anomalyTrainingPeriod!: number | null;
	@attr('string') anomalyAdaptability!: string | null;
}
